// Device integration constants — extracted from App.jsx for shared use
// Patent claims exercised: P-001 18-24

export const DEVICE_TYPES = {
  APPLE: 'apple',
  FITBIT: 'fitbit',
  GARMIN: 'garmin',
  SAMSUNG: 'samsung',
  WITHINGS: 'withings',
  WHOOP: 'whoop',
  OURA: 'oura',
  DEXCOM: 'dexcom',
  MANUAL: 'manual'
};

export const getDeviceDisplayName = (deviceType) => {
  const displayNames = {
    [DEVICE_TYPES.APPLE]: 'Apple Watch / Health',
    [DEVICE_TYPES.FITBIT]: 'Fitbit',
    [DEVICE_TYPES.GARMIN]: 'Garmin',
    [DEVICE_TYPES.SAMSUNG]: 'Samsung Galaxy Watch',
    [DEVICE_TYPES.WITHINGS]: 'Withings',
    [DEVICE_TYPES.WHOOP]: 'WHOOP',
    [DEVICE_TYPES.OURA]: 'Oura Ring',
    [DEVICE_TYPES.DEXCOM]: 'Dexcom CGM',
    [DEVICE_TYPES.MANUAL]: 'Manual Entry'
  };
  return displayNames[deviceType] || deviceType;
};

// Wearable device types — all via HealthKit/Health Connect (FDD Architecture May 2026)
export const WEARABLE_DEVICE_TYPES = ['apple', 'samsung'];
// Medical device types — all via HealthKit/Health Connect (no direct vendor integrations)
export const MEDICAL_DEVICE_TYPES = [];
// Apple Health Bridge recognized medical devices (sync via HealistHealthSync iOS app)
export const APPLE_HEALTH_BRIDGE_DEVICES = [
  // Smart Scales & Body Composition
  { name: 'Renpho Smart Scale', category: 'Body Composition', description: 'Weight, body fat %, muscle mass, bone mass, water %, BMI, and visceral fat index.', icon: '⚖️' },
  { name: 'Eufy Smart Scale', category: 'Body Composition', description: 'Weight, BMI, and body fat percentage synced via Apple Health.', icon: '⚖️' },
  { name: 'QardioBase', category: 'Body Composition', description: 'Smart scale with weight and BMI tracking synced to Apple Health.', icon: '⚖️' },
  { name: 'Garmin Index S2', category: 'Body Composition', description: 'Weight, BMI, body fat %, and muscle mass synced via Garmin Connect to Apple Health.', icon: '⚖️' },
  // Blood Pressure Monitors
  { name: 'Omron Blood Pressure Monitor', category: 'Blood Pressure', description: 'Systolic, diastolic, and pulse readings via Omron Connect. FDA-cleared clinical accuracy.', icon: '🩺' },
  { name: 'QardioArm', category: 'Blood Pressure', description: 'Wireless blood pressure monitor with systolic, diastolic, and heart rate tracking.', icon: '🩺' },
  { name: 'iHealth Blood Pressure Monitor', category: 'Blood Pressure', description: 'FDA-cleared wireless BP monitor syncing systolic, diastolic, and pulse to Apple Health.', icon: '🩺' },
  // Pulse Oximeters
  { name: 'Masimo MightySat', category: 'Pulse Oximeter (SpO2)', description: 'Clinical-grade blood oxygen saturation (SpO2) and perfusion index.', icon: '🫁' },
  { name: 'iHealth Air Pulse Oximeter', category: 'Pulse Oximeter (SpO2)', description: 'Fingertip pulse oximeter syncing SpO2 readings to Apple Health.', icon: '🫁' },
  // ECG / Heart Rhythm
  { name: 'AliveCor KardiaMobile', category: 'ECG / Heart Rhythm', description: 'Single-lead ECG recordings with AFib detection. FDA-cleared for personal use.', icon: '❤️' },
  { name: 'Apple Watch ECG', category: 'ECG / Heart Rhythm', description: 'Single-lead ECG from Apple Watch Series 4+. AFib detection with FDA clearance.', icon: '⌚' },
  // Blood Glucose (CGM via HealthKit)
  { name: 'Abbott FreeStyle Libre', category: 'Blood Glucose (CGM)', description: 'Continuous glucose readings synced to Apple Health via LibreLink app.', icon: '📊' },
  { name: 'Medtronic Guardian Connect', category: 'Blood Glucose (CGM)', description: 'CGM glucose readings and alerts synced to Apple Health.', icon: '📊' },
  { name: 'Biolinq Shine', category: 'Blood Glucose (CGM)', description: 'Newly FDA-cleared needle-free CGM. Glucose readings synced via Apple Health.', icon: '📊' },
  // Thermometers
  { name: 'Kinsa Smart Thermometer', category: 'Body Temperature', description: 'Connected thermometer syncing temperature readings to Apple Health.', icon: '🌡️' },
  { name: 'iHealth Thermometer', category: 'Body Temperature', description: 'No-contact infrared thermometer with Apple Health sync.', icon: '🌡️' },
  // Sleep Trackers
  { name: 'Eight Sleep Pod', category: 'Sleep Tracker', description: 'Smart mattress cover tracking sleep stages, heart rate, HRV, and respiratory rate.', icon: '🛏️' },
  // Fitness Wearables (via HealthKit — no direct Healist integration)
  { name: 'Polar (Beat / Flow)', category: 'Fitness Wearable', description: 'Heart rate, workouts, and sleep synced to Apple Health via Polar Flow.', icon: '⌚' },
  { name: 'Suunto', category: 'Fitness Wearable', description: 'Workout and heart rate data synced to Apple Health.', icon: '⌚' },
  { name: 'Coros', category: 'Fitness Wearable', description: 'Workouts, heart rate, and SpO2 synced to Apple Health.', icon: '⌚' },
  { name: 'Amazfit / Zepp', category: 'Fitness Wearable', description: 'Steps, heart rate, sleep, SpO2, and workouts synced via Zepp app to Apple Health.', icon: '⌚' },
  // Reproductive Health Devices
  { name: 'Natural Cycles Thermometer', category: 'Reproductive Health', description: 'Basal temperature tracking for cycle monitoring. Syncs to Apple Health.', icon: '🌡️' },
];
